import React, {useEffect, useState} from 'react';
import {View} from '@unthinkable/react-core-components';
import {TextRenderer} from '@unthinkable/react-text-input';
import {TableHeader} from '../../../components/header/TableHeader';
import {BasicTable} from '../../../components/table/Table.js';
import routeLink from '../../../constant/routeLink.js';
import {hospitalizationMedicationStyle} from './style/HospitalizationMedicationTable';
import {combineText} from '../../../utils/commonMethod';
import {useMediaQuery} from '../../../modules/auth/hooks/useMediaquery';
import {useNavigate} from 'react-router-dom';
import {useAuth} from 'src/modules/auth/hooks/useAuth';
import {ENCOUNTER_STATUS} from 'src/constant/encounterStatus';
import {status} from 'src/constant/status';
import checkAuthorization from 'src/services/accessService';
import {action, entity} from 'src/constant/authorization';
import {Confirm} from 'src/components/confirm';
import modalMessages from 'src/constant/ModalMessage';
import {useToast} from '@unthinkable/react-toast';
import {useInvoke} from 'src/hooks';
import images from 'src/assets/images';
import {Icon} from 'src/components/icon';
import {HttpAuthService} from 'src/services';

export const HospitalizationMedication = props => {
  const {encounter, showHeader = true, renderActions = true} = props;
  const {isMobile} = useMediaQuery();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const RenderAction = ({row, encounter}) => {
    const notesTask = encounter?.taskInfo?.find(
      task => task.type === 'NotesTask',
    );
    const toast = useToast();
    const invoke = useInvoke({
      method: 'put',
      eventSourceId: ['addMedication'],
      throwError: true,
    });
    const {user} = useAuth();
    if (
      !row.medicationApproved &&
      encounter?.status !== ENCOUNTER_STATUS.BILLABLE &&
      encounter?.status !== ENCOUNTER_STATUS.INCOMPLETE &&
      notesTask?.status !== status.complete
    ) {
      return (
        encounter?.taskInfo?.length > 1 &&
        checkAuthorization(user, entity.medication, action.approve) && (
          <Confirm
            title={modalMessages.medicationTaskApproval.title}
            secondaryTitle={row.name}
            message={modalMessages.medicationTaskApproval.message}
            confirmText={modalMessages.medicationTaskApproval.confirmText}
            onConfirm={async () => {
              const result = await invoke({
                uri: `${routeLink.getMedication}/${row._id}`,
                data: {
                  medicationApproved: true,
                },
              });
              toast(result);
            }}>
            <Icon src={images.checkCircle} />
          </Confirm>
        )
      );
    } else if (row?.medicationApproved) {
      return (
        <View style={hospitalizationMedicationStyle.actionContainer}>
          <Icon src={images.contactSuccess} />
        </View>
      );
    }
  };
  const fetchMedications = async () => {
    try {
      const result = await HttpAuthService.get(routeLink.getMedication, {
        params: {
          filter: {encounterId: encounter?._id , status:"Active"},
          fields: {
            drugName: 1,
            dose: 1,
            frequency: 1,
            direction: 1,
            prescriberId: {
              firstName: 1,
              lastName: 1,
            },
            status: 1,
            estimatedDaysRemaining: 1,
            medicationApproved: 1,
            fillDate: 1,
            lastUpTo: 1,
          },
        },
      });
      setData(result.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedications();
  }, [encounter]);

  return (
    <View
      style={
        isMobile
          ? hospitalizationMedicationStyle.mainContainerMobile
          : hospitalizationMedicationStyle.mainContainer
      }>
      {showHeader && <TableHeader title={'New Hospitalization Medication'} />}
      <BasicTable
        loading={loading}
        noDataText={
          encounter?.medicationStatus === 'success' && data.length === 0
            ? 'No New Medication Prescribed'
            : 'No Data Found'
        }
        variant={'outline'}
        eventSourceId={'addMedication'}
        onRowPress={({row}) => {
          navigate(`medicationDetails/${row?._id}`);
        }}
        data={data}
        columns={[
          {
            header: 'Name',
            field: 'drugName',
            render: props => (
              <TextRenderer
                {...props}
                styles={{
                  ...props.styles,
                  text: {
                    ...props.styles.text,
                    textDecoration:
                      props?.row?.status == 'Inactive'
                        ? 'line-through'
                        : 'none',
                  },
                }}
              />
            ),
          },
          {
            header: 'Dose',
            field: 'dose',
            type: 'text',
          },
          {
            header: 'Frequency',
            field: 'frequency',
            type: 'text',
          },
          {
            header: 'Directions',
            field: 'direction',
            type: 'text',
          },
          {
            header: 'Prescriber',
            render: ({row}) => {
              return (
                <TextRenderer
                  value={combineText(
                    row?.prescriberId?.firstName,
                    row?.prescriberId?.lastName,
                  )}
                />
              );
            },
          },
          {
            render: props => <RenderAction {...props} encounter={encounter} />,
            visible: renderActions,
          },
        ]}
      />
    </View>
  );
};
